import { createReducer } from 'deox'
import {
  setAccount,
  setActiveTokenSaleAddress,
  setBalance,
  setBalanceEth,
  setBalanceLPT,
  setBalanceTokenSale,
  setDesiredNetworkId,
  setEthUsdPrice,
  setIsEthRaise,
  setNewClaimChain,
} from './actions'
import { IWeb3Reducer } from '../../types/reducerTypes'

const initialState: IWeb3Reducer = {
  balance: '0',
  balanceLPT: '0',
  balanceEth: '0',
  balanceTokenSale: '0',
  activeTokenSaleAddress: '',
  isEthRaise: false,
  account: '',
  newClaimChain: -1,
  desiredNetworkId: Number(process.env.REACT_APP_BASE_NETWORK_ID ?? 1),
  ethUsdPrice: 0,
}

const web3Reducer = createReducer(initialState, (handleAction) => [
  handleAction(setBalance, (state, { payload }) => ({
    ...state,
    balance: payload,
  })),
  handleAction(setBalanceLPT, (state, { payload }) => ({
    ...state,
    balanceLPT: payload,
  })),
  handleAction(setAccount, (state, { payload }) => ({
    ...state,
    account: payload,
  })),
  handleAction(setAccount, (state, { payload }) => ({
    ...state,
    account: payload,
  })),
  handleAction(setNewClaimChain, (state, { payload }) => ({
    ...state,
    newClaimChain: payload,
  })),
  handleAction(setDesiredNetworkId, (state, { payload }) => ({
    ...state,
    desiredNetworkId: payload,
  })),
  handleAction(setBalanceEth, (state, { payload }) => ({
    ...state,
    balanceEth: payload,
  })),
  handleAction(setIsEthRaise, (state, { payload }) => ({
    ...state,
    isEthRaise: payload,
  })),
  handleAction(setBalanceTokenSale, (state, { payload }) => ({
    ...state,
    balanceTokenSale: payload,
  })),
  handleAction(setActiveTokenSaleAddress, (state, { payload }) => ({
    ...state,
    activeTokenSaleAddress: payload,
  })),
  handleAction(setEthUsdPrice, (state, { payload }) => ({
    ...state,
    ethUsdPrice: payload,
  })),
])

export default web3Reducer
